import { Box } from '@mui/material';

export default function Flag() {
  return (
    <Box display="flex">
      <Box sx={{ backgroundColor: 'green', width: 5, height: 30, borderBottomLeftRadius: 20 }} />
      <Box sx={{ backgroundColor: 'yellow', width: 5, height: 30 }} />
      <Box sx={{ backgroundColor: 'red', width: 5, height: 30, borderBottomRightRadius: 20 }} />
    </Box>
  );
}
